
<section class="topAreaSearch">
  <div class="topAreaSearch__container">
    <h2 class="topAreaSearch__title">宴会・パーティ会場を都道府県から探す</h2>
    <div class="ui three column grid segment">
      <div v-for="area in consts.SHOP_AREA" v-if="area.value && detailsOf(area.value).length > 0" class="column">
        <div class="topAreaSearch__areaDetails">
          <a v-for="areaDetail in detailsOf(area.value)" :href="'/' + area.prefecture + '/A' + area.value + '/AD' + areaDetail.value + '/'">{{ areaDetail.label }}</a>
        </div>
      </div>
    </div>
  </div>
</section>
